import { render, staticRenderFns } from "./cloak.vue?vue&type=template&id=bdda61a6&scoped=true&"
import script from "./cloak.vue?vue&type=script&lang=js&"
export * from "./cloak.vue?vue&type=script&lang=js&"
import style0 from "./cloak.vue?vue&type=style&index=0&id=bdda61a6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdda61a6",
  null
  
)

export default component.exports